export default "__VITE_ASSET__bc86d146__"